<template>
  <path
    d="M21.41 9.41018L16.58 4.58018C16.21 4.21018 15.7 4.00018 15.17 4.00018H4C2.9 4.00018 2 4.90018 2 6.00018V18.0102C2 19.1102 2.89 20.0002 3.99 20.0002H20C21.1 20.0002 22 19.1002 22 18.0002V10.8302C22 10.3002 21.79 9.79018 21.41 9.41018ZM15 5.50018L20.5 11.0002H16C15.45 11.0002 15 10.5502 15 10.0002V5.50018Z"
  />
</template>
